module.exports = __webpack_public_path__ + "static/media/ellam.b0d6e728.png";